<style lang="less" scoped>
@import '../../../style/common/variable';
.zlkDetails{position: relative;width: 100%;display: flex;flex-direction: column;font-family: AlibabaPuHuiTi-Medium;}
.first{display: flex;flex-direction: column;width: 810px;margin-right: 40px;}
.details{text-align: left;margin-left: 36px;}
@media screen and (max-width: @max-screen) {
  .zlkDetails{width: 100vw;
    .first{width: 100vw; margin-right: 0;}
  }
}
</style>

<template>
  <div class="zlkDetails">
    <div class="first">
      <Details class="details"></Details>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 资料库详情内容页面
 * 安进 2021.06.23数据库接入数据
 */
import Details from '../assembly/Details.vue'
export default {
  components: {
    Details
  },
  name: '',
  data()
  {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/ZlkDetails.vue